import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './TermosDeUso.css';

// API base URL based on environment
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_VERCEL_API_URL || 'https://api.veridicus.com.br'
  : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5000';

const TermosDeUso = () => {
  const [termos, setTermos] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTermos();
  }, []);

  const fetchTermos = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/termos-de-uso/active`);
      
      if (response.data.success) {
        setTermos(response.data.data);
      } else {
        setError('Nenhum termo de uso disponível no momento.');
      }
    } catch (error) {
      console.error('Erro ao buscar termos de uso:', error);
      setError('Erro ao carregar os termos de uso. Por favor, tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Carregando termos de uso...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="error-container">
          <p className="error-message">{error}</p>
          <Link to="/" className="back-button">Voltar ao Início</Link>
        </div>
      );
    }

    if (!termos) {
      return (
        <div className="no-content-container">
          <p>Nenhum termo de uso disponível no momento.</p>
          <Link to="/" className="back-button">Voltar ao Início</Link>
        </div>
      );
    }

    return (
      <>
        <div className="termos-header">
          <h1>{termos.title}</h1>
          <div className="termos-meta">
            <span className="version">Versão {termos.version}</span>
            <span className="date">Última atualização: {formatDate(termos.updatedAt || termos.createdAt)}</span>
          </div>
        </div>
        
        <div 
          className="termos-content"
          dangerouslySetInnerHTML={{ __html: termos.content }}
        />
        
        <div className="termos-footer">
          <p className="info-text">
            Ao utilizar nossos serviços, você concorda com estes termos de uso.
          </p>
          <div className="action-buttons">
            <Link to="/" className="back-button">Voltar ao Início</Link>
            <button 
              onClick={() => window.print()} 
              className="print-button"
            >
              Imprimir
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Header />
      <div className="termos-page">
        <div className="termos-container">
          <nav className="breadcrumb">
            <Link to="/">Início</Link>
            <span className="separator">/</span>
            <span className="current">Termos de Uso</span>
          </nav>
          
          {renderContent()}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermosDeUso;